<section class="incidents-page">
  <header>
    <div><h1>Incidents</h1><p>consolidated Cloudwatch back end errors</p></div>
  </header>
  @if (loading) {
    <div class="state" aria-live="polite"><mat-spinner diameter="32"></mat-spinner> Loading incidents…</div>
  }
  @if (error && !loading) {
    <div class="error state" role="alert">{{error}} <button mat-button (click)="load()">Retry</button></div>
  }
  @if (saveError) {
    <div class="error" role="alert">{{saveError}} @if (conflict) {
      <span>Current ownership and status are shown below. Your draft is preserved; review the updated incident before retrying.</span>
    }</div>
  }

  <ng-template #assignmentDialog>
    @if (assignmentTarget; as target) {
      <h2 mat-dialog-title>Assign incident #{{target.id}}</h2>
      <mat-dialog-content class="assignment-dialog">
        <p>Current owner: {{target.ownerName || 'Unassigned'}}</p>
        @if (assigneesLoading) {
          <p role="status">Loading Wallit people…</p>
        }
        @if (assigneesError) {
          <p class="error" role="alert">{{assigneesError}} <button mat-button (click)="openAssignment(target)">Retry</button></p>
        }
        @if (!assigneesLoading && !assigneesError) {
          <mat-form-field appearance="outline">
            <mat-label>Assign to</mat-label>
            <mat-select [(ngModel)]="assigneeId" [disabled]="saving" panelClass="member-addedit-select-search-panel">
              <mat-option [disabled]="true">
                <ngx-mat-select-search [formControl]="assigneeSearch" placeholderLabel="Search by name or email..." noEntriesFoundLabel="No matching people"></ngx-mat-select-search>
              </mat-option>
              @for (person of filteredAssignees; track person) {
                <mat-option [value]="person.id">{{person.name}} · {{person.email}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (!assignees.length) {
            <p>No eligible Wallit people are available.</p>
          }
        }
        @if (saveError) {
          <p class="error" role="alert">{{saveError}} @if (conflict) {
            <span>Current ownership is shown above. Your selection is preserved; review it before retrying.</span>
          }</p>
        }
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-button (click)="closeAssignment()" [disabled]="saving">Cancel</button>
        <button mat-raised-button color="primary" (click)="change(target, 'assign')" [disabled]="saving || assigneesLoading || !!assigneesError || !assigneeId || assigneeId === target.ownerUserId">{{saving ? 'Assigning…' : 'Assign'}}</button>
      </mat-dialog-actions>
    }
  </ng-template>

  @if (!id) {
    <form class="filters" (ngSubmit)="applyFilters()">
      <mat-form-field appearance="outline"><mat-label>Status</mat-label><mat-select name="status" [(ngModel)]="filters.status">@for (option of statuses; track option) {
      <mat-option [value]="option.value">{{option.label}}</mat-option>
    }</mat-select></mat-form-field>
    <mat-form-field appearance="outline"><mat-label>Owner</mat-label><mat-select name="owner" [(ngModel)]="filters.owner"><mat-option value="all">Anyone</mat-option><mat-option value="unassigned">Unassigned</mat-option><mat-option value="me">Me</mat-option>@for (owner of response?.owners; track owner) {
    <mat-option [value]="owner.id">{{owner.name}}</mat-option>
  }</mat-select></mat-form-field>
  <mat-form-field appearance="outline"><mat-label>Severity</mat-label><mat-select name="severity" [(ngModel)]="filters.severity"><mat-option value="">All severities</mat-option>@for (severity of ['critical','high','medium','low']; track severity) {
  <mat-option [value]="severity">{{severity | titlecase}}</mat-option>
}</mat-select></mat-form-field>
<mat-form-field appearance="outline"><mat-label>Service</mat-label><mat-select name="service" [(ngModel)]="filters.service"><mat-option value="">All services</mat-option>@for (service of response?.services; track service) {
<mat-option [value]="service">{{service}}</mat-option>
}</mat-select></mat-form-field>
<mat-form-field appearance="outline" class="search"><mat-label>Search title, rule, ID, or Jira key</mat-label><input matInput name="search" [(ngModel)]="filters.search" maxlength="200"></mat-form-field>
<button mat-raised-button color="primary" type="submit" [disabled]="loading || saving">Apply filters</button>
</form>
@if (response && !loading && !error) {
  <p class="hint">Repeated emails for the same incident share one owner and status.</p>
  <div class="table-wrapper" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="100"
    [scrollWindow]="false" [infiniteScrollDisabled]="loading || loadingMore || saving || !hasMore || !!moreError"
    (scrolled)="loadMore()" tabindex="0" role="region" aria-label="Scrollable incidents"><table mat-table [dataSource]="response.items">
    <ng-container matColumnDef="severity"><th mat-header-cell *matHeaderCellDef>Severity</th><td mat-cell *matCellDef="let row" data-label="Severity"><span class="badge" [class.critical]="row.severity === 'critical'">{{row.severity | titlecase}}</span></td></ng-container>
    <ng-container matColumnDef="title"><th mat-header-cell *matHeaderCellDef>Incident</th><td mat-cell *matCellDef="let row" data-label="Incident"><a [routerLink]="['/superadmin/incidents', row.id]" [queryParams]="filterQueryParams">{{row.title}}</a><small>#{{row.id}} · {{row.ruleName}}</small>@if (row.newActivity) {
    <strong class="activity">New activity since closure</strong>
  }</td></ng-container>
  <ng-container matColumnDef="lastEmailedAt"><th mat-header-cell *matHeaderCellDef>Last emailed</th><td mat-cell *matCellDef="let row" data-label="Last emailed">{{row.lastEmailedAt | date:'MMM d, y, h:mm a z'}}</td></ng-container>
  <ng-container matColumnDef="emailCount"><th mat-header-cell *matHeaderCellDef>Emails</th><td mat-cell *matCellDef="let row" data-label="Emails">{{row.emailCount}}</td></ng-container>
  <ng-container matColumnDef="owner"><th mat-header-cell *matHeaderCellDef>Owner</th><td mat-cell *matCellDef="let row" data-label="Owner">{{row.ownerName || 'Unassigned'}}@if (row.ownerUserId && !row.ownerAvailable) {
  <small>Owner unavailable</small>
}</td></ng-container>
<ng-container matColumnDef="status"><th mat-header-cell *matHeaderCellDef>Status</th><td mat-cell *matCellDef="let row" data-label="Status">{{label(row.status)}}</td></ng-container>
<ng-container matColumnDef="jira"><th mat-header-cell *matHeaderCellDef>Jira</th><td mat-cell *matCellDef="let row" data-label="Jira">@if (row.jiraUrl) {
<a [href]="row.jiraUrl" target="_blank" rel="noopener noreferrer">{{row.jiraIssueKey}}</a>
} @else {
  —
  }<ng-template #noJira>—</ng-template></td></ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>Actions</th>
    <td mat-cell *matCellDef="let row" data-label="Actions">
      <button mat-icon-button type="button" [matMenuTriggerFor]="incidentActions" [disabled]="saving" [attr.aria-label]="'Actions for incident ' + row.id">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #incidentActions="matMenu">
        <a mat-menu-item [routerLink]="['/superadmin/incidents', row.id]" [queryParams]="filterQueryParams"><mat-icon>visibility</mat-icon><span>View</span></a>
        @if (row.actions.claim) {
          <button mat-menu-item type="button" (click)="change(row, 'claim')" [disabled]="saving"><mat-icon>person</mat-icon><span>Assign to me</span></button>
        }
        <button mat-menu-item type="button" (click)="openAssignment(row)" [disabled]="saving"><mat-icon>person_add</mat-icon><span>Assign</span></button>
        <button mat-menu-item type="button" (click)="change(row, 'markDone')" [disabled]="saving"><mat-icon>done</mat-icon><span>Mark done</span></button>
      </mat-menu>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="columns"></tr><tr mat-row *matRowDef="let row; columns: columns"></tr>
</table></div>
@if (!response.items.length) {
  <p class="state">No incidents match these filters.</p>
}
<p role="status">Showing {{response.items.length}} of {{response.total}} incidents@if (loadingMore) {
  <span> · Loading more…</span>
}</p>
@if (moreError) {
  <div class="error" role="alert">{{moreError}} <button mat-stroked-button (click)="loadMore()" [disabled]="loadingMore">Retry loading more</button></div>
}
}
}

@if (id) {
  <a mat-button routerLink="/superadmin/incidents" [queryParams]="filterQueryParams"><mat-icon>arrow_back</mat-icon> Back to incidents</a>
  @if (incident && !loading && !error) {
    <article>
      <h2>#{{incident.id}} · {{incident.title}}</h2>
      <p><span class="badge">{{incident.severity | titlecase}}</span> {{label(incident.status)}} · {{incident.ownerName || 'Unassigned'}} @if (incident.ownerUserId && !incident.ownerAvailable) {
      <span>(Owner unavailable)</span>
    }</p>
    @if (incident.newActivity) {
      <p class="activity">New activity since closure. Review the latest observations and reopen or close again.</p>
    }
    <div class="actions">
      <button mat-stroked-button (click)="openAssignment(incident)" [disabled]="saving">Assign to person</button>
      @if (incident.actions.claim) {
        <button mat-raised-button color="primary" (click)="change(incident, 'claim')" [disabled]="saving">This is mine</button>
      }
      @if (incident.actions.release) {
        <button mat-stroked-button (click)="change(incident, 'release')" [disabled]="saving">Release</button>
      }
      @if (incident.actions.takeover && !takeoverPending) {
        <button mat-stroked-button (click)="takeoverPending = true" [disabled]="saving">Take over</button>
      }
      @if (takeoverPending) {
        <span>Take ownership from {{incident.ownerName}}?</span><button mat-raised-button (click)="change(incident, 'takeover')" [disabled]="saving">Confirm takeover</button><button mat-button (click)="takeoverPending = false" [disabled]="saving">Cancel</button>
      }
      @if (incident.actions.reopen) {
        <button mat-stroked-button (click)="change(incident, 'triage', incident.ownerAvailable ? 'in_progress' : 'open')" [disabled]="saving">{{incident.ownerAvailable ? 'Reopen' : 'Reopen as unassigned'}}</button>
      }
    </div>
    <dl><dt>Rule</dt><dd>{{incident.ruleName}}</dd><dt>Service</dt><dd>{{incident.service}}</dd><dt>Log group</dt><dd>{{incident.logGroupName}}</dd><dt>First seen</dt><dd>{{incident.firstSeenAt | date:'MMM d, y, h:mm:ss a z'}}</dd><dt>Last seen</dt><dd>{{incident.lastSeenAt | date:'MMM d, y, h:mm:ss a z'}}</dd><dt>Occurrences</dt><dd>{{incident.occurrenceCount}}</dd><dt>Emails</dt><dd>{{incident.emailCount}} · Last emailed {{incident.lastEmailedAt | date:'MMM d, y, h:mm:ss a z'}}</dd></dl>
    <form class="edit" (ngSubmit)="change(incident, 'triage')">
      <mat-form-field appearance="outline"><mat-label>Jira issue key or URL</mat-label><input matInput name="jira" [(ngModel)]="jiraDraft" maxlength="300" [attr.aria-invalid]="fieldError === 'jiraIssueKey'"><mat-hint>For example, MM-5938</mat-hint></mat-form-field>
      @if (fieldError === 'jiraIssueKey') {
        <p class="error">{{saveError}}</p>
      }
      @if (incident.jiraUrl) {
        <a [href]="incident.jiraUrl" target="_blank" rel="noopener noreferrer">Open {{incident.jiraIssueKey}}</a>
      }
      <mat-form-field appearance="outline"><mat-label>Resolution note</mat-label><textarea matInput name="note" [(ngModel)]="noteDraft" rows="3" maxlength="2000" [attr.aria-invalid]="fieldError === 'resolutionNote'"></textarea><mat-hint>Required for Won’t do</mat-hint></mat-form-field>
      @if (fieldError === 'resolutionNote') {
        <p class="error">{{saveError}}</p>
      }
      <div class="actions"><button mat-raised-button color="primary" type="submit" [disabled]="saving">Save details</button>@if (incident.actions.close) {
      <button mat-stroked-button type="button" (click)="change(incident, 'triage', 'done')" [disabled]="saving">Mark done</button>
      }@if (incident.actions.close) {
      <button mat-stroked-button type="button" (click)="change(incident, 'triage', 'wont_do')" [disabled]="saving || !noteDraft.trim()">Won’t do</button>
    }</div>
  </form>
  <h3>Current incident samples</h3><p class="hint">These are current log samples, not an archive of the original emails. Closing an incident does not stop notifications.</p>
  @for (sample of incident.sampleEvents; track sample) {
    <pre>{{pretty(sample)}}</pre>
    }@if (!incident.sampleEvents?.length) {
    <p>No sample events recorded.</p>
  }
</article>
}
}
</section>
